document.addEventListener("DOMContentLoaded", () => {
  /** @type {HTMLDialogElement|null} */
  const modal = document.querySelector("[data-mte-quick-view]");

  if (!modal) return;

  /** @type {HTMLImageElement|null} */
  const image = modal.querySelector("[data-mte-quick-view-image]");

  /** @type {HTMLElement|null} */
  const vendor = modal.querySelector("[data-mte-quick-view-vendor]");

  /** @type {HTMLElement|null} */
  const title = modal.querySelector("[data-mte-quick-view-title]");

  /** @type {HTMLElement|null} */
  const price = modal.querySelector("[data-mte-quick-view-price]");

  /** @type {HTMLElement|null} */
  const stock = modal.querySelector("[data-mte-quick-view-stock]");

  /** @type {HTMLAnchorElement|null} */
  const detailsLink = modal.querySelector("[data-mte-quick-view-link]");

  /** @type {HTMLButtonElement|null} */
  const addButton = modal.querySelector("[data-mte-quick-view-add]");

  /** @type {HTMLElement|null} */
  const message = modal.querySelector("[data-mte-quick-view-message]");

  /** @type {string|null} */
  let selectedVariantId = null;

  document.addEventListener("click", (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    /** @type {HTMLButtonElement|null} */
    const trigger = target.closest("[data-mte-quick-view-trigger]");

    if (trigger) {
      selectedVariantId = trigger.dataset.variantId || null;

      const available =
        trigger.dataset.productAvailable === "true";

      if (image) {
        image.src = trigger.dataset.productImage || "";
        image.alt = trigger.dataset.productTitle || "";
      }

      if (vendor) {
        vendor.textContent =
          trigger.dataset.productVendor || "";
      }

      if (title) {
        title.textContent =
          trigger.dataset.productTitle || "";
      }

      if (price) {
        price.textContent =
          trigger.dataset.productPrice || "";
      }

      if (stock) {
        stock.textContent = available
          ? "Disponible para compra"
          : "Agotado";

        stock.classList.toggle(
          "is-sold-out",
          !available,
        );
      }

      if (detailsLink) {
        detailsLink.href =
          trigger.dataset.productUrl || "#";
      }

      if (addButton) {
        addButton.disabled =
          !available || !selectedVariantId;

        addButton.textContent = available
          ? "Agregar al carrito"
          : "Producto agotado";
      }

      if (message) {
        message.textContent = "";
      }

      modal.showModal();
      return;
    }

    const closeButton = target.closest(
      "[data-mte-quick-view-close]",
    );

    if (closeButton || target === modal) {
      modal.close();
    }
  });

  addButton?.addEventListener("click", async () => {
    if (!selectedVariantId || !addButton) return;

    addButton.disabled = true;
    addButton.textContent = "Agregando...";

    if (message) {
      message.textContent = "";
    }

    try {
      const shopify = /** @type {{
        actions?: {
          updateCart?: (input: {
            lines: Array<{
              merchandiseId: string;
              quantity: number;
            }>;
          }) => Promise<{
            cart?: unknown;
            userErrors?: Array<{ message?: string }>;
            warnings?: Array<{ message?: string }>;
          }>;
          openCart?: () => Promise<void>;
        };
      }} */ (
        /** @type {unknown} */ (window.Shopify)
      );

      if (
        !shopify.actions?.updateCart ||
        !shopify.actions?.openCart
      ) {
        throw new Error(
          "El carrito dinámico de Shopify no está disponible.",
        );
      }

      const merchandiseId =
        `gid://shopify/ProductVariant/${selectedVariantId}`;

      const result = await shopify.actions.updateCart({
        lines: [
          {
            merchandiseId,
            quantity: 1,
          },
        ],
      });

      if (result.userErrors?.length) {
        throw new Error(
          result.userErrors[0]?.message ||
            "No se pudo agregar el producto.",
        );
      }

      if (message) {
        message.textContent =
          result.warnings?.[0]?.message ||
          "Producto agregado al carrito.";
      }

      addButton.textContent = "Agregado ✓";

      setTimeout(async () => {
        modal.close();

        addButton.disabled = false;
        addButton.textContent = "Agregar al carrito";

        if (message) {
          message.textContent = "";
        }

        await shopify.actions?.openCart?.();
      }, 700);
    } catch (error) {
      console.error("[MTE Quick View]", error);

      if (message) {
        message.textContent =
          error instanceof Error
            ? error.message
            : "Ocurrió un error. Inténtalo nuevamente.";
      }

      addButton.disabled = false;
      addButton.textContent = "Agregar al carrito";
    }
  });
  modal.addEventListener("close", () => {
    selectedVariantId = null;

    if (message) {
      message.textContent = "";
    }

    if (addButton) {
      addButton.disabled = false;
      addButton.textContent =
        "Agregar al carrito";
    }
  });
});